import { render, staticRenderFns } from "./MarriageReportTwoResult.vue?vue&type=template&id=18e63452&"
import script from "./MarriageReportTwoResult.vue?vue&type=script&lang=js&"
export * from "./MarriageReportTwoResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports